// CabecalhoDeSecao.js — o título de TODA seção da página do livro.
//
// ================= POR QUE ELE EXISTE (17/09/2026) =================
//
// O print da página mostrou cinco seções com cinco títulos diferentes, um
// embaixo do outro: "Ficha técnica" com chapéu laranja e régua, "Sobre o Livro"
// solto, "Autores:" com dois-pontos, "Como funciona a compra" enfiado dentro da
// própria caixa e "Opiniões" solto de novo. Cada seção tinha sido escrita num
// dia, e cada uma com o título do dia. Lida de cima a baixo, a página parecia
// montada com pedaços de sites diferentes.
//
// Um componente só é a única forma de a sexta seção não inventar o sexto
// título.
//
// O DESENHO é o mesmo das vitrines da loja (produto/vitrine/Vitrine.js), um
// degrau menor: chapéu laranja com traço curto, título, e a régua de 2px que
// começa laranja e vira a cor da sombra. As vitrines "Compre junto" e "Da mesma
// área", que também moram nesta página, já usam aquela régua — com este
// componente, a página inteira fala a mesma língua de cima a baixo.
//
// ESPAÇAMENTOS SEM HOMÔNIMO NO BOOTSTRAP (`mb-6`, `pb-3.5`, `mt-1.5`): a loja
// carrega o bootstrap.min.css inteiro, e as classes que ele também declara
// (`mb-5`, `pb-3`…) chegam com !important e valores maiores.
import React from "react";
import { TituloDeSecao } from "../../ui/TituloDeSecao";

// (18/10/2026) No desenho dos outros dois sites: título na League Gothic com
// a última palavra em laranja e o losango embaixo, um degrau menor que o das
// vitrines da home. Ver ui/TituloDeSecao.

/**
 * @param {string} chapeu  Duas ou três palavras em cima do título.
 * @param {string} titulo  O nome da seção.
 * @param {string} id      Vai no <h2>, para a seção apontar para ele com
 *                         `aria-labelledby`.
 * @param {node}   children  Uma ação opcional à direita (link, contagem).
 */
export default function CabecalhoDeSecao({ chapeu, titulo, destaque, id, children, className = "" }) {
  return (
    <TituloDeSecao
      chapeu={chapeu}
      titulo={titulo}
      destaque={destaque}
      id={id}
      acao={children}
      tamanho="text-[2.1rem] md:text-[2.6rem]"
      className={"mb-[1.75rem] " + className}
    />
  );
}
